<template>
    <div :class="['alert text-left', typeClass]" role="alert">
        <span v-html="message" />
        <button type="button" class="close" aria-label="Close" @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'error',
            },
            message: {
                type: String,
                default: '',
            },
        },
        computed: {
            typeClass() {
                switch (this.type) {
                    case 'success':
                    return 'alert-success';
                    case 'warning':
                    return 'alert-warning';
                    case 'info':
                    return 'alert-info';
                    default:
                    return 'alert-danger';
                }
            },
        },
    };
</script>

<style scoped>
    .close {
        float: none;
        position: absolute;
        right: 10px;
        top: 10px;
        color: #7c6b6d;
    }
    .close:hover {
        background: none !important;
        color: black !important;
    }
</style>
